// @flow

import React, { useState } from 'react';
import { func, string, object } from 'prop-types';
import Select from 'react-select';

const SelectVocabularyValue = ({
  id,
  onUpdateSelect,
  emptyValueLabel,
  vocabulary,
}) => {
  let options = [];
  if (vocabulary) {
    options = Object.entries(vocabulary).map(([key, value]) => ({
      label: value,
      value: key,
    }));
  }

  const [value, setValue] = useState(null);

  const onChangeSelect = (option) => {
    const newVal = option?.value ?? '';
    setValue(option);
    onUpdateSelect(newVal);
  };

  return (
    <div className="select">
      <Select
        inputId={id}
        name={id}
        value={value}
        onChange={onChangeSelect}
        options={options}
        placeholder={emptyValueLabel}
        classNames={{
          control: (state) => 'react-select__control',
        }}
        isClearable
      />
    </div>
  );
};

SelectVocabularyValue.propTypes = {
  id: string,
  emptyValueLabel: string,
  vocabulary: object,
  onUpdateSelect: func,
};

export default SelectVocabularyValue;
